import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import { IFormSection } from "../../model/form/FormSection";
import Application from "../../Application";
import { IFormSectionPresentationModel } from "../form/model/FormSectionPresentationModel";

export interface TApplicantFormDetailsPresenter extends TLoadingAwarePresenter {
  formSectionList: IFormSectionPresentationModel[];
  formId: number;
}

export interface IApplicantFormDetailsPresenter
  extends TApplicantFormDetailsPresenter,
    TPresentable {
  loadFormSectionList(formSectionList: IFormSection[]): void;
}

const defaultState: TApplicantFormDetailsPresenter = {
  formSectionList: [],
  formId: NaN
};

const ApplicantFormDetailsPresenter = withStore<
  IApplicantFormDetailsPresenter,
  TApplicantFormDetailsPresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): IApplicantFormDetailsPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TApplicantFormDetailsPresenter>();

    loader.start("applicantFormDetailsLoader");

    const loadFormSectionList = async (formSectionList: IFormSection[]) => {
      _store.update({
        formSectionList
      });

      loader.stop("applicantFormDetailsLoader");
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      loadFormSectionList
    };
  },
  defaultState
);

export default ApplicantFormDetailsPresenter;
